export const repairSmithFieldOps = window.AMS_CONFIG;
